export default "__VITE_ASSET__yHs8vQqp__"